import Spinner from 'components/public/Spinner/Spinner';
import { alturaContainer } from 'utils/constants';
import NoResponse from 'pages/auxiliares/NoResponse';
import { Box } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from 'utils/redux/store/store';
import { fetchGrillaTalleres } from 'utils/redux/features/talleresGrillaSlice';
import { useEffect } from 'react';
import PageContainer from 'components/PageContainer/PageContainer';
import GrillaTalleres from 'components/public/GrillaTalleres/GrillaTalleres';

const GaleriaTalleres = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { talleresGrilla, loadingTalleresGrilla, errorTalleresGrilla } = useSelector(
    (state: RootState) => state.talleresGrilla
  );

  useEffect(() => {
    dispatch(fetchGrillaTalleres());
  }, [dispatch]);

  return (
    <PageContainer marginBottom={true}>
      {loadingTalleresGrilla ? (
        <Spinner />
      ) : (
        <Box minHeight={alturaContainer}>
          {errorTalleresGrilla ? (
            <NoResponse />
          ) : (
            <GrillaTalleres
              titulo="Talleres disponibles"
              elementos={talleresGrilla}
              path="taller"
              textoBoton="Ver taller"
              mostrarFechas={false}
            />
          )}
        </Box>
      )}
    </PageContainer>
  );
};

export default GaleriaTalleres;
